// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpCookiesAlmacena1 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_cookies_almacena_1";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpCookiesAlmacena1 {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Adgang til information ved hjælp af andre teknologier end cookies",
                "de": "Zugriff auf Informationen mit anderen technischen Hilfsmitteln als Cookies.",
                "en": "Access to information using technologies other than cookies",
                "fr": "Accès aux informations à l\\'aide de technologies autres que les cookies",
                "it": "Accesso ai dati usando tecnologie diverse dai cookies",
                "nl": "De toegang tot informatie vindt plaats met behulp van andere technologieën dan cookies",
                "pt": "Acesso à informação utilizando tecnologias diferentes dos cookies",
                "ru": "Доступ к информации с использованием технологий, разных  файлов cookie.",
                "pt-BR": "Acesso à informações usando tecnologias diferentes de cookies"
            },
            "defecto": "Sólo se accede a la información a través de cookies"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
